
module dgUtils {

    function dgFilterByMany($parse: ng.IParseService): Function {
        return (collection: Array<any>, propExpression: string, values: Array<string>) => {

            collection = (angular.isObject(collection)) ? (Array as any).from(collection) : collection;

            if (!angular.isArray(collection) || angular.isUndefined(propExpression)) {
                return collection;
            }

            return collection.filter(function (elm) {
                return values.indexOf($parse(propExpression)(elm)) == -1;
            });
        }
    }
    dgFilterByMany.$inject = ['$parse'];


    angular.module('dgUtils')
        .filter('dgFilterByMany', dgFilterByMany);
}